import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BrandDomain } from './domain.model';

const BASE = environment.contractUrl;

/** CRUD for MANDANT_DOMAIN — the allowed web domains of a single brand. */
@Injectable({ providedIn: 'root' })
export class BrandDomainService {
  private readonly http = inject(HttpClient);

  listBrandDomains(brandId: number): Observable<BrandDomain[]> {
    return this.http.get<BrandDomain[]>(`${BASE}/brands/${brandId}/domains`);
  }

  createBrandDomain(brandId: number, body: BrandDomain): Observable<BrandDomain> {
    return this.http.post<BrandDomain>(`${BASE}/brands/${brandId}/domains`, body);
  }

  updateBrandDomain(brandId: number, domain: string, body: { mailDomain: boolean }): Observable<void> {
    return this.http.put<void>(`${BASE}/brands/${brandId}/domains/${encodeURIComponent(domain)}`, body);
  }

  deleteBrandDomain(brandId: number, domain: string): Observable<void> {
    return this.http.delete<void>(`${BASE}/brands/${brandId}/domains/${encodeURIComponent(domain)}`);
  }
}
